export default {
  welcome: 'Add assets here and start your project!',
  tool: {
    zoomout: 'zoom out',
    zoomin: 'zoom in',
  },
  loading: 'Loading',
  loadfail: 'Loading failed',
}
